import { RECIPES } from './data';
import { RecipeOld, RecipeCategoryTypes } from './recipes.model';

export const getRecipeByCategory = (r: RecipeOld[]) => r.reduce((obj, itm) => {
  if (obj[itm.category] === undefined) { obj[itm.category] = []; }
  obj[itm.category].push(itm);
  return obj;
}, {} as Record<RecipeCategoryTypes, RecipeOld[]>);

export const getRecipeMapById = (r: RecipeOld[]) => r.reduce((obj, itm) => {
  obj[itm.id] = itm;
  return obj;
}, {} as Record<string, RecipeOld>);

export const getRecipeById = (id: string) => RECIPES.find((itm) => {
  return itm.id === id;
});
